<div @fondoAnimado
     id="fondo">
</div>
<div id="contenido">
  <ng-content></ng-content>
</div>